import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * Service untuk mengelola Event
 * @namespace EventSvc
 */
export default {
  /**
   * Mendapatkan semua data Event
   * @function get
   * @return {Promise} Promise yang berisi response dari server
   */
  get: async (params) => {
    const { data } = await axiosInstance.get('/master/config_event', {
      params: {
        ...params,
      },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mendapatkan data Event berdasarkan ID
   * @function getById
   * @param {number} id - ID dari Event yang ingin di dapatkan
   * @return {Promise} Promise yang berisi response dari server
   */
  getById: async (id) => {
    const { data } = await axiosInstance.get(`/master/config_event/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Membuat data Event baru
   * @function create
   * @param {object} data - Data yang ingin di buat
   * @return {Promise} Promise yang berisi response dari server
   */
  create: async (Data) => {
    const { data } = await axiosInstance.post('/master/config_event', Data, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mengupdate data Event yang sudah ada
   * @function update
   * @param {number} id - ID dari Event yang ingin di update
   * @param {object} data - Data yang ingin di update
   * @return {Promise} Promise yang berisi response dari server
   */
  update: async (id, Data) => {
    const { data } = await axiosInstance.put(`/master/config_event/${id}`, Data, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Menghapus data Event yang sudah ada
   * @function delete
   * @param {number} id - ID dari Event yang ingin di hapus
   * @return {Promise} Promise yang berisi response dari server
   */
  delete: async (id) => {
    const { data } = await axiosInstance.delete(`/master/config_event/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
};
